module.exports = __webpack_public_path__ + "static/media/avatar.0d612714.jpeg";